import io from 'socket.io-client';
import config from '../../api/config.json';

const { protocol, ipServerSKT, portServerSKT } = config;
export let socket = { id: '', connected: false, emit: () => {} };

setInterval(() => {
  if (!socket.connected) {
    socket = io(`${protocol}://${ipServerSKT}:${portServerSKT}`, {
      reconnection: false
    });
    try {
      socket.on('connect', () => {
        console.log('socket store conected ', socket.id);

        socket.on('disconnect', () => {
          console.log('socket store disconnected');
          socket.disconnect();
        });
      });
    } catch (err) {
      console.error(err);
    }
  }
}, 1000);
